import state from './reviews-state';
import mutations from './reviews-mutations';
import actions from './reviews-actions';
import getters from './reviews-getters';

const reviewState = state();

reviewState.unfinishedReviews = window.__RMP_USER_REVIEWS__;

export default {
  namespaced: true,
  state: reviewState,
  mutations,
  actions,
  getters,
};
